import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-sinistres',
  templateUrl: './sinistres.component.html',
  styleUrls: ['./sinistres.component.css']
})
export class SinistresComponent implements OnInit {

  title = 'Mes sinistres';
  
  constructor(private titleService: Title) { 
    this.titleService.setTitle(environment.APP_TITLE + ' | '+ this.title);
  }

  ngOnInit(): void {
  }

}
